import type { AsyncData } from '#app';
import type {
  IModelListQueryParamsRequest,
  IModelResponse,
} from '~/services/base/dto/base.dto';
import type {
  IModelCreatePromptLibraryRequest,
  IModelPromptLibraryResponse,
} from './dto/prompt-library.dto';

export class PromptLibraryRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getPromptLibrary(
    params: IModelListQueryParamsRequest
  ): Promise<AsyncData<IModelResponse<IModelPromptLibraryResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/prompt-library`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getPromptLibraryById(
    id: string | number
  ): Promise<AsyncData<IModelResponse<IModelPromptLibraryResponse>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/prompt-library${id}`,
      this.configService
    );
    return dataResult;
  }

  async createPromptLibrary(
    params: IModelCreatePromptLibraryRequest
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/prompt-library`,
      this.configService,
      {
        method: 'POST',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async updatePromptLibrary(
    params: IModelCreatePromptLibraryRequest
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/prompt-library`,
      this.configService,
      {
        method: 'PUT',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async deletePromptLibrary(
    id: string | number
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/prompt-library/${id}`, this.configService, {
      method: 'DELETE'
    });
    return dataResult;
  }
}
